import { cn } from "@client/utils/cn";
import { CurrencyInput as SharedCurrencyInput, type Input } from "@sfc/ui";

/** Preserve the form API: className styles the wrapper, values are whole dollars. */
export function CurrencyInput({
  className,
  ...props
}: React.ComponentProps<typeof Input> & {
  onValueChange?: (value: number) => void;
}) {
  return (
    <SharedCurrencyInput
      mode="formatted"
      wrapperClassName={cn("relative", className)}
      {...props}
    />
  );
}
